import { useLayoutEffect } from "react";

export const useResetScrollPosition = (): void => {
  useLayoutEffect(() => {
    const homeElement = document.querySelector("#home-main");

    homeElement?.scrollTo(0, 0);
  }, []);
};
